var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "url(#sigle-dot-icon-linear-1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "black",
    fillOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 8,
    r: 2,
    fill: "url(#sigle-dot-icon-linear-2)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 8,
    r: 2,
    fill: "black",
    fillOpacity: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 14,
    r: 2,
    fill: "url(#sigle-dot-icon-linear-3)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 14,
    r: 2,
    fill: "black",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sigle-dot-icon-linear-1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(90) scale(2)"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop-one",
    stopColor: "#5573FF"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop-two",
    offset: 1,
    stopColor: "#4441E9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sigle-dot-icon-linear-2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 8) rotate(90) scale(2)"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop-one",
    stopColor: "#5573FF"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop-two",
    offset: 1,
    stopColor: "#4441E9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sigle-dot-icon-linear-3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 14) rotate(90) scale(2)"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop-one",
    stopColor: "#5573FF"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop-two",
    offset: 1,
    stopColor: "#4441E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.b614e7dd10005b772e1ceb5b098b31df.svg";
export { ForwardRef as ReactComponent };